import CheckCircleIcon from '@/comp/common/icons/CheckCircleIcon';
import ExclamationCircleIcon from '@/comp/common/icons/ExclamationCircleIcon';
import { t } from 'i18next';
import React from 'react';

export type ModalType = 'unresolved' | 'confirmation' | 'success' | 'initError' | 'cancelTest';

export interface ButtonConfig {
  text: string;
  onClick: () => void;
  variant: 'primary' | 'secondary';
}

export interface MobileCommonDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  type: ModalType;
  title?: string;
  message: string;
  primaryButton: ButtonConfig;
  secondaryButton?: ButtonConfig;
  numberOfUnresolvedCompressors?: number;
}

export const getDefaultTitle = (type: MobileCommonDrawerProps['type']): string => {
  switch (type) {
    case 'unresolved':
      return t('unresolvedCompressorStates');
    case 'confirmation':
      return t('Confirm submission');
    case 'success':
      return t('testCompletedSuccessfully');
    case 'initError':
      return t('TEST_NOT_INITIATED_TITLE');

    case 'cancelTest':
      return t('cancel_validation_test');
    default:
      return '';
  }
};

export const getIcon = (type: ModalType) => {
  switch (type) {
    case 'unresolved':
      return <ExclamationCircleIcon size={24} />;
    case 'initError':
      return <ExclamationCircleIcon size={24} />;
    case 'success':
      return <CheckCircleIcon />;
    default:
      return null;
  }
};
